
















































































































































































































































import { PropType } from 'vue';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import { DataTableHeader } from 'vuetify';
import { ContractStateEnum, IContract, IContractItem } from '@/models';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ContractItemDetailOptionButton from './ContractItemDetailOptionButton.vue';
import ContractItemFormDialog from './ContractItemFormDialog.vue';

const baseMixins = mixins(auth);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    contactItemFormDialog: InstanceType<typeof ContractItemFormDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'ContractDetailCard',

    components: {
      ContractItemFormDialog,
      ContractItemDetailOptionButton,
      ErrorAlert
    },

    props: {
      contract: {
        type: Object as PropType<IContract>
      }
    },

    computed: {
      totalValue(): number {
        return this.contract.items.reduce(
          (accumulator: number, currentItem: IContractItem) =>
            accumulator + currentItem.net_price,
          0
        );
      },

      contractId(): number {
        return Number(this.$route.params.id);
      },

      isContractEditable(): boolean {
        return this.contract.state !== ContractStateEnum.Terminated;
      },

      contractItemHeaders(): DataTableHeader[] {
        const headers: DataTableHeader[] = [
          {
            text: '#',
            value: 'index',
            width: 5,
            sortable: false,
            class: 'primary white--text subtitle-1'
          },
          {
            text: 'Item',
            value: 'item',
            width: 300,
            sortable: false,
            class: 'primary white--text subtitle-1'
          },
          {
            text: 'Quantity',
            value: 'quantity',
            align: 'center',
            sortable: false,
            width: 90,
            class: 'primary white--text subtitle-1 min-td'
          },
          {
            text: 'Unit Price',
            value: 'unit_price',
            align: 'start',
            width: 100,
            sortable: false,
            class: 'primary white--text subtitle-1'
          },
          {
            text: 'Net Price',
            value: 'net_price',
            align: 'start',
            width: 100,
            sortable: false,
            class: 'primary white--text subtitle-1'
          }
        ];

        if (this.isContractEditable) {
          headers.push({
            text: '',
            value: 'actions',
            align: 'end',
            width: 10,
            sortable: false,
            class: 'primary white--text subtitle-1'
          });
        }

        return headers;
      }
    },

    methods: {
      openContractItemFormDialog(item?: IContractItem) {
        this.$refs.contactItemFormDialog.open(item);
      }
    }
  });
